module.exports = __webpack_public_path__ + "static/media/magentaHeartOutlined.de24de8b.svg";